<template>
  <section class="platform-workspace">
    <table-toolbar
      :search.sync="pfName"
      :show-search="true"
      :show-refresh="true"
      :show-export="true"
      :show-column-settings="true"
      :columns="allConfigurableColumns"
      :visible-columns.sync="visibleColumns"
      :default-columns="defaultColumnsList"
      :fixed-columns="['# ID', '平台名称', '操作']"
      :min-selected="4"
      search-placeholder="输入关键字搜索平台..."
      export-confirm-title="确定要导出当前筛选后的平台规划数据吗？"
      @search-change="pfNameChange"
      @refresh="handleReset"
      @export="handleExport"
    >
      <template slot="left">
        <el-button type="primary" size="small" icon="el-icon-plus" class="btn-action" @click="handleAddPlatform">新增平台</el-button>

        <el-select
          v-model="searchForm.platformType"
          size="small"
          placeholder="选择平台类型"
          clearable
          class="filter-select"
          @change="handleSearchChange"
        >
          <el-option value="" label="全部类型"></el-option>
          <el-option v-for="item in platformTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </template>

    </table-toolbar>

    <table-page
      :loading="loading"
      :empty="tables.length === 0"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :total="totalCount"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
      :show-top-pagination="!!totalCount"
      :show-bottom-pagination="!!totalCount"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @retry="handleReset"
    >
      <el-table
        :data="tables"
        stripe
        style="width: 100%"
        class="premium-table"
      >
        <el-table-column key="col-id" prop="platformId" width="110">
          <template slot="header">
            <span class="premium-header-title"><span class="header-icon-hash">#</span> ID</span>
          </template>
          <template slot-scope="scope">
            <span class="cell-id">{{ scope.row.platformId }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-name" prop="name" min-width="190">
          <template slot="header">
            <span class="premium-header-title">平台名称</span>
          </template>
          <template slot-scope="scope">
            <el-link type="primary" class="platform-name-link" @click="handleUpdatePlatform(scope.$index, scope.row)">
              {{ scope.row.name }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column v-if="visibleColumns.includes('platformType')" key="col-platformType" prop="platformType" min-width="130">
          <template slot="header">
            <span class="premium-header-title">平台类型</span>
          </template>
          <template slot-scope="scope">
            <el-tag
              :class="['platform-type-tag', getPlatformTypeTagType(scope.row.platformType) === 'purple' ? 'el-tag--purple' : '']"
              :type="getPlatformTypeTagType(scope.row.platformType) === 'purple' ? 'info' : getPlatformTypeTagType(scope.row.platformType)"
              size="small"
            >
              {{ getPlatformTypeLabel(scope.row.platformType) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column v-if="visibleColumns.includes('channelRange')" key="col-channelRange" min-width="190">
          <template slot="header">
            <span class="premium-header-title">渠道号范围</span>
          </template>
          <template slot-scope="scope">
            <span class="channel-range-text">
              {{ scope.row.min }} <span class="range-arrow">~</span> {{ scope.row.max }}
            </span>
          </template>
        </el-table-column>

        <el-table-column key="col-actions" width="86" align="center">
          <template slot="header">
            <span class="premium-header-title">操作</span>
          </template>
          <template slot-scope="scope">
            <el-dropdown @command="handleActionCommand($event, scope.row, scope.$index)" trigger="hover">
              <el-button size="mini" class="action-btn" circle icon="el-icon-more-outline"></el-button>
              <el-dropdown-menu slot="dropdown" class="premium-dropdown-menu">
                <el-dropdown-item command="edit">
                  <i class="el-icon-edit"></i> 编辑平台
                </el-dropdown-item>
                <el-dropdown-item command="delete" class="dropdown-danger">
                  <i class="el-icon-delete"></i> 删除平台
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </table-page>

    <el-drawer
      :visible.sync="dialogVisible"
      direction="rtl"
      :size="drawerSize"
      destroy-on-close
      :before-close="handleDrawerBeforeClose"
      custom-class="platform-form-drawer"
      :with-header="false"
    >
      <div class="detail-workspace">
        <div class="breadcrumb-header">
          <div class="header-top-row">
            <div class="header-left">
              <span class="header-title">
                <span class="header-title-icon"><i :class="type ? 'el-icon-edit-outline' : 'el-icon-plus'"></i></span>
                {{ type ? `编辑：${form.platformId} - ${form.name || ''}` : '新增平台' }}
              </span>
            </div>

            <div class="header-right-buttons">
              <el-button size="small" @click="handleCloseDialog"><i class="el-icon-back"></i> 返回列表</el-button>
              <el-button type="success" size="small" @click="handleSaveDialog">保存</el-button>
            </div>
          </div>
        </div>

        <div class="detail-content box">
          <el-form :model="form" label-position="right" label-width="130px" size="small" :rules="rules" ref="form" class="form-container">
            <el-form-item label="平台 ID" prop="platformId">
              <el-input v-model.number="form.platformId" :disabled="type" placeholder="请输入平台 ID"></el-input>
            </el-form-item>
            <el-form-item label="平台类型" prop="platformType">
              <el-select v-model.trim="form.platformType" filterable placeholder="请选择平台类型" style="width: 100%">
                <el-option value="0">0 - Unknown</el-option>
                <el-option v-for="item in platformTypes" :key="item.value" :label="item.value + ' - ' + item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="平台名称" prop="name">
              <el-input v-model.trim="form.name" placeholder="请输入平台名称"></el-input>
            </el-form-item>
            <el-form-item label="最小渠道号" prop="min">
              <el-input v-model.number="form.min" placeholder="请输入最小渠道号"></el-input>
            </el-form-item>
            <el-form-item label="最大渠道号" prop="max">
              <el-input v-model.number="form.max" placeholder="请输入最大渠道号"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-drawer>
  </section>
</template>

<script>
import api from '@/api/channel'
import options from '@/common/options'
import * as XLSX from 'xlsx'
import TablePage from '@/components/TablePage/index.vue'
import TableToolbar from '@/components/TableToolbar/index.vue'

export default {
  name: 'index',
  components: { TablePage, TableToolbar },
  created () {
    this.fetchData(this.pageSize, this.currentPage)
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    tables () {
      let list = this.tableData
      if (this.searchForm.platformType !== '' && this.searchForm.platformType !== null && this.searchForm.platformType !== undefined) {
        list = list.filter(item => Number(item.platformType) === Number(this.searchForm.platformType))
      }
      return list
    },
    drawerSize () {
      if (this.viewportWidth <= 768) return '100%'
      if (this.viewportWidth <= 1200) return '72%'
      return '50%'
    }
  },
  watch: {
    appId (val, oldVal) {
      if (val === oldVal) {
        return
      }
      this.fetchData(this.pageSize, this.currentPage)
    }
  },
  data () {
    const min = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入最小渠道号'))
      } else if (typeof (value) !== 'number') {
        callback(new Error('请输入数字'))
      } else if (value < 0) {
        callback(new Error('请输入有效数字'))
      } else if (value < this.appId * 1000) {
        callback(new Error('最小渠道号应大于等于' + this.appId * 1000))
      } else if (value >= (this.appId + 1) * 1000) {
        callback(new Error('最小渠道号应小于等于' + (this.appId + 1) * 1000))
      } else {
        callback()
      }
    }
    const max = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入最大渠道号'))
      } else if (typeof (value) !== 'number') {
        callback(new Error('请输入数字'))
      } else if (value < 0) {
        callback(new Error('请输入有效数字'))
      } else if (value < this.form.min) {
        callback(new Error('请大于最小渠道号'))
      } else if (value >= (this.appId + 1) * 1000) {
        callback(new Error('最大渠道号应小于' + (this.appId + 1) * 1000))
      } else if (value <= this.appId * 1000) {
        callback(new Error('最大渠道号应大于' + this.appId * 1000))
      } else {
        callback()
      }
    }
    return {
      viewportWidth: window.innerWidth,
      loading: false,
      pageSize: 20,
      currentPage: 1,
      totalCount: 0,
      tableData: [],
      platformData: {},
      dialogVisible: false,
      pfName: '',
      platformTypes: options.platformTypes,
      searchForm: {
        platformType: ''
      },
      visibleColumns: ['platformType', 'channelRange'],
      defaultColumnsList: ['platformType', 'channelRange'],
      allConfigurableColumns: [
        { value: 'platformType', label: '平台类型' },
        { value: 'channelRange', label: '渠道号范围' }
      ],
      form: {
        appId: this.appId,
        platformType: 1
      },
      AppOptions: [],
      type: false,
      index: 0,
      rules: {
        platformId: [{ type: 'number', required: true, message: '请输入数字，且不能为空', trigger: 'blur' }],
        min: [{ required: true, validator: min, trigger: 'blur' }],
        max: [{ required: true, validator: max, trigger: 'blur' }],
        name: [{ type: 'string', required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.viewportWidth = window.innerWidth
    },
    fetchData (pageSize, currentPage) {
      this.loading = true
      const params = {
        size: pageSize,
        page: currentPage,
        appId: this.appId,
        name: this.pfName
      }
      Promise.all([
        api.getPlatformDataByPage(params),
        api.getAppData()
      ]).then(([platformRes, appRes]) => {
        this.tableData = platformRes.data
        this.totalCount = platformRes.total
        this.AppOptions = appRes
      }).finally(() => {
        this.loading = false
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData(val, this.currentPage)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData(this.pageSize, val)
    },
    pfNameChange (val) {
      this.pfName = val
      this.currentPage = 1
      this.fetchData(this.pageSize, this.currentPage)
    },
    handleSearchChange () {
      this.currentPage = 1
    },
    handleReset () {
      this.fetchData(this.pageSize, this.currentPage)
    },
    handleExport () {
      if (!this.tables || this.tables.length === 0) {
        this.$message.warning('当前暂无可导出的平台规划数据')
        return
      }
      const exportData = this.tables.map(row => {
        return {
          平台ID: row.platformId,
          平台名称: row.name,
          平台类型: this.getPlatformTypeLabel(row.platformType),
          最小渠道号: row.min,
          最大渠道号: row.max,
          渠道号范围: `${row.min} ~ ${row.max}`
        }
      })
      const workbook = XLSX.utils.book_new()
      const worksheet = XLSX.utils.json_to_sheet(exportData)
      XLSX.utils.book_append_sheet(workbook, worksheet, '平台规划')
      XLSX.writeFile(workbook, `平台规划-${new Date().getTime()}.xlsx`)
      this.$message.success('数据导出成功')
    },
    handleAddPlatform () {
      this.type = false
      const platformId = this.tableData.length ? this.tableData[this.tableData.length - 1].platformId : 0
      this.form = {
        platformId: platformId + 1,
        appId: this.appId
      }
      this.dialogVisible = true
    },
    handleUpdatePlatform (index, rowData) {
      this.type = true
      this.index = index
      const data = Object.assign({}, rowData)
      this.form = data
      this.dialogVisible = true
    },
    handleSaveDialog () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.form)
          const f = this.type ? api.changePlatform : api.addPlatform
          f(params).then(res => {
            if (this.type) {
              this.tableData.splice(this.index, 1, res)
            } else {
              this.tableData.push(res)
            }
            this.$message.success(this.type ? '修改成功' : '添加成功')
            this.dialogVisible = false
          })
        } else {
          return false
        }
      })
    },
    handleDeletePlatform (id, i) {
      this.$confirm('确定删除吗?', '提示', { type: 'warning' }).then(() => {
        api.deletePlatform(id).then(() => {
          this.tableData.splice(i, 1)
          this.$message.success('删除成功')
        })
      })
    },
    handleCloseDialog () {
      this.dialogVisible = false
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    handleDrawerBeforeClose (done) {
      this.handleCloseDialog()
      done()
    },
    handleActionCommand (command, row, index) {
      if (command === 'edit') {
        this.handleUpdatePlatform(index, row)
      } else if (command === 'delete') {
        this.handleDeletePlatform(row.id, index)
      }
    },
    getPlatformTypeLabel (type) {
      if (Number(type) === 0) return 'Unknown'
      const found = this.platformTypes.find(item => Number(item.value) === Number(type))
      return found ? found.label : type
    },
    getPlatformTypeTagType (type) {
      const map = {
        1: '',
        2: 'purple',
        3: 'warning',
        4: 'danger'
      }
      return map[type] || 'info'
    }
  }
}
</script>

<style scoped>
.platform-workspace {
  padding: 16px 24px;
}

.btn-action {
  flex-shrink: 0;
  height: 32px;
  padding: 0 16px;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
}

.btn-action:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.filter-select {
  width: 150px;
  flex-shrink: 0;
}

.filter-select :deep(.el-input__inner) {
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  border-color: #E2E8F0;
  background-color: #FFFFFF;
  color: var(--text-main);
  font-weight: 500;
  transition: all 0.2s ease;
}

.filter-select :deep(.el-input__inner:hover) {
  border-color: #CBD5E1;
}

.filter-select :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

.btn-setting-icon-large {
  background-color: #FFFFFF !important;
  border-color: #E2E8F0 !important;
  color: #64748B !important;
  border-radius: 8px !important;
  height: 32px !important;
  width: 32px !important;
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0 !important;
}

.btn-setting-icon-large:hover {
  background-color: #F8FAFC !important;
  border-color: #CBD5E1 !important;
  color: var(--text-main) !important;
}

.premium-table {
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  font-size: 13px !important;
  color: var(--text-main) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif !important;
}

.premium-table::before {
  display: none !important;
}

.premium-table :deep(.el-table__header-wrapper) th,
.premium-table :deep(.el-table__fixed-header-wrapper) th,
.premium-table :deep(.el-table__fixed-right-header-wrapper) th,
.premium-table :deep(th.el-table__fixed-column) {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.premium-table :deep(.el-table__row) td {
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.premium-table :deep(.el-table__row) {
  transition: background-color 0.2s ease;
}

.premium-table :deep(.el-table__row:hover) td {
  background-color: var(--bg-hover) !important;
}

.premium-table :deep(.el-table__body tr.hover-row > td),
.premium-table :deep(.el-table__body tr.hover-row.current-row > td),
.premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

.premium-header-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: inherit;
}

.header-icon-hash {
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 13.5px;
  font-weight: 900;
  color: inherit;
}

.cell-id {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace !important;
  font-size: 12.5px !important;
  font-weight: 600;
  color: var(--text-muted);
}

.platform-name-link {
  font-size: 13.5px !important;
  font-weight: 700 !important;
  text-decoration: none !important;
  cursor: pointer;
}

.platform-name-link:hover,
.platform-name-link:focus {
  text-decoration: none !important;
}

.platform-type-tag {
  min-width: 68px;
  text-align: center;
  border-radius: 6px;
  font-weight: 600;
}

.platform-type-tag.el-tag--purple {
  color: #7c3aed;
  background-color: #f5f3ff;
  border-color: #ddd6fe;
}

.channel-range-text {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.range-arrow {
  color: #94a3b8;
}

/* 深色模式适配 */
html.dark .platform-type-tag.el-tag--purple {
  color: #a78bfa !important;
  background-color: rgba(124, 58, 237, 0.15) !important;
  border-color: rgba(124, 58, 237, 0.3) !important;
}

html.dark .platform-type-tag.el-tag--info {
  color: #94a3b8 !important;
  background-color: rgba(148, 163, 184, 0.15) !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

html.dark .platform-type-tag.el-tag--warning {
  color: #fbbf24 !important;
  background-color: rgba(245, 158, 11, 0.15) !important;
  border-color: rgba(245, 158, 11, 0.3) !important;
}

html.dark .platform-type-tag.el-tag--danger {
  color: #f87171 !important;
  background-color: rgba(239, 68, 68, 0.15) !important;
  border-color: rgba(239, 68, 68, 0.3) !important;
}

html.dark .channel-range-text {
  color: var(--text-main);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

html.dark .range-arrow {
  color: var(--text-muted);
}

html.dark .detail-workspace {
  background-color: var(--bg-page) !important;
}

html.dark .breadcrumb-header {
  background-color: var(--bg-card) !important;
  border-bottom-color: var(--border-color) !important;
}

html.dark .breadcrumb-header .header-title {
  color: var(--text-main) !important;
}

html.dark .detail-content {
  background-color: var(--bg-card) !important;
  border-color: var(--border-color) !important;
}

.action-btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #64748B;
  font-size: 12px;
  transition: all 0.2s ease;
}

.action-btn:hover {
  background: #F1F5F9;
  border-color: #CBD5E1;
  color: var(--text-main);
}

.dropdown-danger,
.dropdown-danger i {
  color: #ef4444 !important;
}

.premium-dialog :deep(.el-dialog) {
  border-radius: 10px;
  overflow: hidden;
}

.premium-dialog :deep(.el-dialog__header) {
  padding: 18px 24px 14px;
  border-bottom: 1px solid #f1f5f9;
}

.premium-dialog :deep(.el-dialog__title) {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-main);
}

.premium-dialog :deep(.el-dialog__body) {
  padding: 20px 24px;
}

.premium-dialog :deep(.el-dialog__footer) {
  padding: 14px 24px 20px;
  border-top: 1px solid #f1f5f9;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.dialog-footer .el-button + .el-button {
  margin-left: 0;
}

.btn-save {
  min-width: 72px;
  border-radius: 8px !important;
  font-weight: 600 !important;
}

.column-settings-dialog :deep(.el-dialog) {
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

.column-settings-dialog .dialog-body-desc {
  font-size: 13px;
  color: #64748b;
  margin-top: -6px;
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.6;
}

.column-settings-dialog .limit-warning {
  color: #f59e0b;
  font-weight: 600;
}

.column-settings-dialog .checkbox-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background-color: #f8fafc;
}

.column-settings-dialog .dialog-column-group-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  margin-top: 14px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.column-settings-dialog .dialog-column-group-title:first-of-type {
  margin-top: 0;
}

.column-settings-dialog .dialog-column-group-title i {
  color: var(--primary-color);
  font-size: 14px;
}

.column-settings-dialog .fixed-columns-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 6px;
}

.column-settings-dialog .fixed-column-card {
  padding: 8px 16px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
  user-select: none;
}

.column-settings-dialog .popover-divider {
  height: 1px;
  margin: 18px 0;
  background: #e2e8f0;
}

.column-settings-dialog .dialog-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 0;
  width: 100%;
}

.column-settings-dialog .dialog-checkbox-group .el-checkbox {
  display: inline-flex;
  align-items: center;
  width: calc(33.33% - 10px);
  box-sizing: border-box;
  margin-right: 10px !important;
  margin-bottom: 6px !important;
  padding: 8px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.2s ease;
}

.column-settings-dialog .dialog-checkbox-group .el-checkbox:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.column-settings-dialog .dialog-checkbox-group .el-checkbox.is-checked {
  border-color: rgba(37, 99, 235, 0.4);
  background: rgba(37, 99, 235, 0.02);
}

.column-settings-dialog .dialog-checkbox-group .el-checkbox.is-disabled {
  cursor: not-allowed;
  opacity: 1;
}

.column-settings-dialog .dialog-checkbox-group .el-checkbox.is-disabled.is-checked {
  border-color: rgba(37, 99, 235, 0.35);
  background: rgba(37, 99, 235, 0.03);
}

.column-settings-dialog .dialog-checkbox-group .el-checkbox__label {
  color: #334155;
  font-size: 13px;
  font-weight: 500;
}

.column-settings-dialog .dialog-checkbox-group .el-checkbox.is-disabled .el-checkbox__label {
  color: #64748b;
}

.column-settings-dialog .dialog-checkbox-group .el-checkbox__inner {
  border-radius: 4px;
}

.column-settings-dialog .btn-dialog-action {
  padding: 8px 18px !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
}

.column-settings-dialog :deep(.el-dialog__footer) {
  text-align: inherit !important;
}

.column-settings-dialog .dialog-footer {
  justify-content: space-between;
}

.right-buttons-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.detail-workspace {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  background-color: #f8fafc;
}

.breadcrumb-header {
  position: sticky;
  top: 0;
  z-index: 100;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin: 0;
  padding: 12px 20px;
  background: #ffffff;
  border-bottom: 1px solid #E2E8F0;
}

.header-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.header-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #1E293B;
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
}

.header-title-icon {
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.08);
  color: var(--primary-color);
}

.header-right-buttons {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
  margin-left: auto;
}

.detail-content {
  flex: 1;
  overflow-y: auto;
  margin: 12px;
  padding: 18px 20px;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.form-container {
  width: 100%;
  max-width: none;
}

.form-container :deep(.el-form-item) {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.form-container :deep(.el-form-item__label) {
  flex: 0 0 25%;
  width: 25% !important;
  min-width: 112px;
  max-width: 180px;
  padding-right: 12px;
  color: #475569;
  font-weight: 600;
  line-height: 32px;
  text-align: left;
}

.form-container :deep(.el-form-item__content) {
  flex: 1 1 75%;
  min-width: 0;
  margin-left: 0 !important;
}

.form-container :deep(.el-select) {
  width: 100%;
}

@media (max-width: 1200px) {
  .platform-workspace {
    padding: 16px;
  }

  .filter-select {
    width: 140px;
  }
}

@media (max-width: 768px) {
  .breadcrumb-header {
    padding: 12px 16px;
  }

  .header-top-row,
  .header-left {
    align-items: flex-start;
    flex-direction: column;
  }

  .header-right-buttons {
    width: 100%;
    justify-content: flex-end;
  }

  .form-container :deep(.el-form-item) {
    display: block;
  }

  .form-container :deep(.el-form-item__label) {
    width: 100% !important;
    max-width: none;
    padding-right: 0;
  }

  .column-settings-dialog .dialog-checkbox-group .el-checkbox {
    width: 100%;
  }
}
</style>
